// Default keyboard shortcuts configuration for PaceEstate

export const SHORTCUT_CATEGORIES = {
  NAVIGATION: 'navigation',
  ACTIONS: 'actions',
  SEARCH: 'search',
  SELECTION: 'selection',
  MODAL: 'modal',
  OTHER: 'other',
};

export const SHORTCUT_SCOPES = {
  GLOBAL: 'global',
  PAGE: 'page',
  MODAL: 'modal',
  TABLE: 'table',
};

export const defaultShortcuts = {
  // Navigation shortcuts (g + key pattern for "go to")
  'g d': {
    action: 'navigate',
    path: '/dashboard',
    description: 'Go to Dashboard',
    category: SHORTCUT_CATEGORIES.NAVIGATION,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
  'g s': {
    action: 'navigate',
    path: '/staff/sales',
    description: 'Go to Sales',
    category: SHORTCUT_CATEGORIES.NAVIGATION,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
  'g i': {
    action: 'navigate',
    path: '/inventory',
    description: 'Go to Inventory',
    category: SHORTCUT_CATEGORIES.NAVIGATION,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
  'g l': {
    action: 'navigate',
    path: '/leads',
    description: 'Go to Leads',
    category: SHORTCUT_CATEGORIES.NAVIGATION,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
  'g c': {
    action: 'navigate',
    path: '/calendar',
    description: 'Go to Calendar',
    category: SHORTCUT_CATEGORIES.NAVIGATION,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
  'g a': {
    action: 'navigate',
    path: '/appointments',
    description: 'Go to Appointments',
    category: SHORTCUT_CATEGORIES.NAVIGATION,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
  'g r': {
    action: 'navigate',
    path: '/reports',
    description: 'Go to Reports',
    category: SHORTCUT_CATEGORIES.NAVIGATION,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
  'g p': {
    action: 'navigate',
    path: '/profile',
    description: 'Go to Profile',
    category: SHORTCUT_CATEGORIES.NAVIGATION,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
  'g t': {
    action: 'navigate',
    path: '/settings',
    description: 'Go to Settings',
    category: SHORTCUT_CATEGORIES.NAVIGATION,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },

  // Action shortcuts
  'n': {
    action: 'create',
    description: 'Create new item',
    category: SHORTCUT_CATEGORIES.ACTIONS,
    scope: SHORTCUT_SCOPES.PAGE,
    enabled: true,
    excludeInputs: true,
  },
  'e': {
    action: 'edit',
    description: 'Edit selected',
    category: SHORTCUT_CATEGORIES.ACTIONS,
    scope: SHORTCUT_SCOPES.PAGE,
    enabled: true,
    excludeInputs: true,
  },
  'd': {
    action: 'delete',
    description: 'Delete selected',
    category: SHORTCUT_CATEGORIES.ACTIONS,
    scope: SHORTCUT_SCOPES.PAGE,
    enabled: true,
    excludeInputs: true,
  },
  'r': {
    action: 'refresh',
    description: 'Refresh page',
    category: SHORTCUT_CATEGORIES.ACTIONS,
    scope: SHORTCUT_SCOPES.PAGE,
    enabled: true,
    excludeInputs: true,
  },
  'ctrl+s': {
    action: 'save',
    description: 'Save changes',
    category: SHORTCUT_CATEGORIES.ACTIONS,
    scope: SHORTCUT_SCOPES.PAGE,
    enabled: true,
    preventDefault: true,
  },
  'cmd+s': {
    action: 'save',
    description: 'Save changes',
    category: SHORTCUT_CATEGORIES.ACTIONS,
    scope: SHORTCUT_SCOPES.PAGE,
    enabled: true,
    preventDefault: true,
  },

  // Search shortcuts
  '/': {
    action: 'search',
    description: 'Focus search',
    category: SHORTCUT_CATEGORIES.SEARCH,
    scope: SHORTCUT_SCOPES.PAGE,
    enabled: true,
    excludeInputs: true,
  },
  'cmd+k': {
    action: 'globalSearch',
    description: 'Global search',
    category: SHORTCUT_CATEGORIES.SEARCH,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
    preventDefault: true,
  },
  'ctrl+k': {
    action: 'globalSearch',
    description: 'Global search',
    category: SHORTCUT_CATEGORIES.SEARCH,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
    preventDefault: true,
  },
  'cmd+shift+p': {
    action: 'commandPalette',
    description: 'Command palette',
    category: SHORTCUT_CATEGORIES.SEARCH,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
    preventDefault: true,
  },
  'ctrl+shift+p': {
    action: 'commandPalette',
    description: 'Command palette',
    category: SHORTCUT_CATEGORIES.SEARCH,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
    preventDefault: true,
  },

  // Selection shortcuts (in tables)
  'j': {
    action: 'selectNext',
    description: 'Select next row',
    category: SHORTCUT_CATEGORIES.SELECTION,
    scope: SHORTCUT_SCOPES.TABLE,
    enabled: true,
    excludeInputs: true,
  },
  'k': {
    action: 'selectPrev',
    description: 'Select previous row',
    category: SHORTCUT_CATEGORIES.SELECTION,
    scope: SHORTCUT_SCOPES.TABLE,
    enabled: true,
    excludeInputs: true,
  },
  'x': {
    action: 'toggleSelect',
    description: 'Toggle selection',
    category: SHORTCUT_CATEGORIES.SELECTION,
    scope: SHORTCUT_SCOPES.TABLE,
    enabled: true,
    excludeInputs: true,
  },
  'cmd+a': {
    action: 'selectAll',
    description: 'Select all',
    category: SHORTCUT_CATEGORIES.SELECTION,
    scope: SHORTCUT_SCOPES.TABLE,
    enabled: true,
    preventDefault: true,
  },
  'ctrl+a': {
    action: 'selectAll',
    description: 'Select all',
    category: SHORTCUT_CATEGORIES.SELECTION,
    scope: SHORTCUT_SCOPES.TABLE,
    enabled: true,
    preventDefault: true,
  },

  // Vim-style navigation (optional, can be toggled)
  'h': {
    action: 'navigateLeft',
    description: 'Navigate left',
    category: SHORTCUT_CATEGORIES.SELECTION,
    scope: SHORTCUT_SCOPES.TABLE,
    enabled: false, // Disabled by default, can be enabled in settings
    vim: true,
    excludeInputs: true,
  },
  'l': {
    action: 'navigateRight',
    description: 'Navigate right',
    category: SHORTCUT_CATEGORIES.SELECTION,
    scope: SHORTCUT_SCOPES.TABLE,
    enabled: false,
    vim: true,
    excludeInputs: true,
  },

  // Modal/Form shortcuts
  'escape': {
    action: 'close',
    description: 'Close modal/cancel',
    category: SHORTCUT_CATEGORIES.MODAL,
    scope: SHORTCUT_SCOPES.MODAL,
    enabled: true,
  },
  'enter': {
    action: 'submit',
    description: 'Submit form',
    category: SHORTCUT_CATEGORIES.MODAL,
    scope: SHORTCUT_SCOPES.MODAL,
    enabled: true,
    // Only active when button is focused
    requireFocus: true,
  },
  'tab': {
    action: 'nextField',
    description: 'Next field',
    category: SHORTCUT_CATEGORIES.MODAL,
    scope: SHORTCUT_SCOPES.MODAL,
    enabled: true,
  },
  'shift+tab': {
    action: 'prevField',
    description: 'Previous field',
    category: SHORTCUT_CATEGORIES.MODAL,
    scope: SHORTCUT_SCOPES.MODAL,
    enabled: true,
  },

  // Other shortcuts
  '?': {
    action: 'showHelp',
    description: 'Show shortcuts help',
    category: SHORTCUT_CATEGORIES.OTHER,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
    excludeInputs: true,
  },
  'cmd+/': {
    action: 'toggleHelp',
    description: 'Toggle help panel',
    category: SHORTCUT_CATEGORIES.OTHER,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
  'ctrl+/': {
    action: 'toggleHelp',
    description: 'Toggle help panel',
    category: SHORTCUT_CATEGORIES.OTHER,
    scope: SHORTCUT_SCOPES.GLOBAL,
    enabled: true,
  },
};

// Command palette actions
export const commandPaletteActions = [
  // Navigation
  { id: 'nav-dashboard', label: 'Dashboard', path: '/dashboard', icon: 'dashboard', shortcut: 'g d' },
  { id: 'nav-sales', label: 'Sales', path: '/staff/sales', icon: 'shopping_cart', shortcut: 'g s' },
  { id: 'nav-inventory', label: 'Inventory', path: '/inventory', icon: 'inventory', shortcut: 'g i' },
  { id: 'nav-leads', label: 'Leads', path: '/leads', icon: 'trending_up', shortcut: 'g l' },
  { id: 'nav-calendar', label: 'Calendar', path: '/calendar', icon: 'calendar_today', shortcut: 'g c' },
  { id: 'nav-appointments', label: 'Appointments', path: '/appointments', icon: 'event', shortcut: 'g a' },
  { id: 'nav-reports', label: 'Reports', path: '/reports', icon: 'assessment', shortcut: 'g r' },
  { id: 'nav-clients', label: 'Clients', path: '/clients', icon: 'people' },
  { id: 'nav-invoices', label: 'Invoices', path: '/invoices', icon: 'receipt' },
  { id: 'nav-profile', label: 'Profile', path: '/profile', icon: 'account_circle', shortcut: 'g p' },
  { id: 'nav-settings', label: 'Settings', path: '/settings', icon: 'settings', shortcut: 'g t' },

  // Actions
  { id: 'action-new', label: 'Create New', action: 'create', icon: 'add', shortcut: 'n' },
  { id: 'action-edit', label: 'Edit', action: 'edit', icon: 'edit', shortcut: 'e' },
  { id: 'action-delete', label: 'Delete', action: 'delete', icon: 'delete', shortcut: 'd' },
  { id: 'action-refresh', label: 'Refresh', action: 'refresh', icon: 'refresh', shortcut: 'r' },
  { id: 'action-save', label: 'Save', action: 'save', icon: 'save', shortcut: 'Ctrl+S' },

  // Search
  { id: 'search-global', label: 'Global Search', action: 'globalSearch', icon: 'search', shortcut: 'Cmd+K' },
  { id: 'search-page', label: 'Search Page', action: 'search', icon: 'search', shortcut: '/' },

  // Help
  { id: 'help-shortcuts', label: 'Keyboard Shortcuts', action: 'showHelp', icon: 'help', shortcut: '?' },
];

// Helper function to normalize shortcuts for display
export const normalizeShortcut = (shortcut) => {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

  return shortcut
    .replace(/cmd\+/gi, isMac ? '⌘' : 'Ctrl+')
    .replace(/ctrl\+/gi, isMac ? '⌃' : 'Ctrl+')
    .replace(/shift\+/gi, isMac ? '⇧' : 'Shift+')
    .replace(/alt\+/gi, isMac ? '⌥' : 'Alt+')
    .split(' ')
    .map(key => key.charAt(0).toUpperCase() + key.slice(1))
    .join(' ');
};

// Helper function to check if event matches shortcut
export const matchesShortcut = (event, shortcut) => {
  const keys = shortcut.toLowerCase().split('+');
  const lastKey = keys[keys.length - 1];

  const hasCtrl = keys.includes('ctrl') || keys.includes('cmd');
  const hasShift = keys.includes('shift');
  const hasAlt = keys.includes('alt');

  const eventKey = event.key.toLowerCase();

  // Check modifiers
  if (hasCtrl && !(event.ctrlKey || event.metaKey)) return false;
  if (!hasCtrl && (event.ctrlKey || event.metaKey)) return false;
  if (hasShift && !event.shiftKey) return false;
  if (!hasShift && event.shiftKey && lastKey !== eventKey) return false;
  if (hasAlt && !event.altKey) return false;
  if (!hasAlt && event.altKey) return false;

  // Check key
  return eventKey === lastKey;
};

// Helper to check if element is input
export const isInputElement = (element) => {
  if (!element) return false;

  const tagName = element.tagName.toLowerCase();
  const isContentEditable = element.isContentEditable;

  return (
    tagName === 'input' ||
    tagName === 'textarea' ||
    tagName === 'select' ||
    isContentEditable
  );
};

export default defaultShortcuts;
